import { useMemo } from "react"

// Reine Ableitung ohne eigenen State: null (kein Fetch) ergibt eine leere Liste,
// ohne Markierung bleiben alle Routen.
export const useFilterMarkedRoutes = (analysedRoutes, markedVesselNames) =>
  useMemo(() => {
    if (!Array.isArray(analysedRoutes)) return []
    const names = new Set((markedVesselNames ?? []).map((m) => m?.vesselName))
    if (names.size === 0) return analysedRoutes
    return analysedRoutes.filter(
      (route) => names.has(route.points?.vesselName) || names.has(route.vesselName),
    )
  }, [analysedRoutes, markedVesselNames])
